import { PersonalPlanTable } from '@legacy/screens/PersonalPlan/components/PersonalPlanTable/PersonalPlanTable';
import { useTranslation } from 'react-i18next';
import { MultiLineTranslation } from '@legacy/components/utils/MultiLineTranslation';
import { ReportingWidgetCard } from '../ReportingWidgetCard';

export const PersonalPlanWidget = () => {
  const { t } = useTranslation('personalPlan');
  return (
    <ReportingWidgetCard
      title={
        <>
          {t('HeadingText')} (
          <abbr title={t('HoursLabel')}>{t('HoursAbbrLabel')}</abbr>)
        </>
      }
      name="personalPlan"
      infoIconText={
        <MultiLineTranslation
          translatedContent={t('DescriptionText')}
          paragraphComponent="span"
        />
      }
      hasAction
    >
      <PersonalPlanTable data-automation-id="FrontPagePersonalPlanWidget" />
    </ReportingWidgetCard>
  );
};
